import { showWarning } from '@spike/notifications-action';
import { setRole } from 'actions/login/LoginActions';
import { convertStaff } from 'actions/staff/StaffConverter';
import { useAuth } from 'hooks';
import { StaffWebSocketsMessage } from 'model/WebSockets';
import { FunctionComponent, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { websocketLog } from './websocketLog';
import { useActionCableChannel } from './useActionCableChannel';

const StaffWebSockets: FunctionComponent = () => {
    const auth = useAuth();
    const dispatch = useDispatch();

    const onReceived = useCallback(
        (message: StaffWebSocketsMessage) => {
            websocketLog('message', 'StaffWebSockets', { staffId: message.staff?.id });

            const staff = convertStaff(message.staff);
            const newRole = staff.role ? { ...staff.role } : undefined;
            const staffId = staff.id ?? 0;

            if (auth.user && auth.user.staffId === staffId && newRole && auth.user.role.id !== newRole.id) {
                dispatch(showWarning('Your role or access level has been changed.'));
                setRole(newRole, staffId, dispatch);
            }
        },
        [auth.user, dispatch]
    );

    useActionCableChannel<StaffWebSocketsMessage>({
        channel: 'StaffChannel',
        params: { marketplace_id: auth.marketplaceId },
        enabled: Boolean(auth.signedIn && auth.marketplaceId),
        onReceived,
        subscriptionDeps: [auth.marketplaceId],
        logLabel: 'StaffWebSockets'
    });

    return null;
};

export default StaffWebSockets;
